import { assignmentStage, localDay, normalizeDashboardEvent, schoolNoticesForDay } from "./dashboardGadgets";

export const CLASSROOM_QUEST_TYPES = ["lesson", "assignment", "quiz", "test", "project", "practice", "field_trip", "reading", "review"];

export function nextClassDate(subject, from = localDay(), calendar = {}) {
    const schedule = subject?.class_schedule || {};
    const days = schedule.days?.length ? schedule.days : ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
    const cursor = new Date(`${from}T12:00:00`);
    const ownCalendar = Object.fromEntries(["holidays", "vacations", "daysOff", "items"].map((key) => [key,
        (calendar[key] || []).filter((item) => (!item.child_id || String(item.child_id) === String(subject?.child_id)) && (!item.profileView || item.profileView === "school" || String(item.profileView) === String(subject?.child_id))),
    ]));
    for (let offset = 0; offset < 366; offset += 1) {
        if (days.includes(cursor.toLocaleDateString("en-US", { weekday: "long" })) && !schoolNoticesForDay(ownCalendar, localDay(cursor)).length) return localDay(cursor);
        cursor.setDate(cursor.getDate() + 1);
    }
    return from;
}

export const questsForClass = (events, childId, subjectId) => events.map(normalizeDashboardEvent).filter((event) =>
    event.child_id === String(childId) && event.subject_id === String(subjectId) &&
    !event.archived && !event.deleted_from_dashboard &&
    CLASSROOM_QUEST_TYPES.includes(String(event.type || event.quest_type || "").toLowerCase()) && !event.is_calendar_session && !event.is_timed_session
);

export const classToDoForDay = (events, childId, subjectId, date) => questsForClass(events, childId, subjectId).filter((event) => {
    if (assignmentStage(event) !== "active" || ["archived", "cancelled", "canceled"].includes(event.status)) return false;
    const start = String(event.date_start || event.date || event.scheduled_date || event.due_date || "").slice(0, 10);
    const end = String(event.due_date || event.date_end || start).slice(0, 10);
    return !start || (start <= date && date <= end);
});
